import { render, staticRenderFns } from "./benefits.vue?vue&type=template&id=cee590fe&scoped=true&"
import script from "./benefits.vue?vue&type=script&lang=js&"
export * from "./benefits.vue?vue&type=script&lang=js&"
import style0 from "./benefits.vue?vue&type=style&index=0&id=cee590fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee590fe",
  null
  
)

export default component.exports